import { render, staticRenderFns } from "./WithdrawManager.vue?vue&type=template&id=0ab52b2a&scoped=true"
import script from "./WithdrawManager.vue?vue&type=script&lang=js"
export * from "./WithdrawManager.vue?vue&type=script&lang=js"
import style0 from "./WithdrawManager.vue?vue&type=style&index=0&id=0ab52b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab52b2a",
  null
  
)

export default component.exports